import HttpClient from "./http-client";
import { TravelContract } from "../types/all";

class TravelApi extends HttpClient {
    public constructor() {
        super(process.env.VUE_APP_BASE_API_URL);
    }

    public getContracts = (params: string) => this.instance.get<any>("/travel" + params);

    public getContract = (policyNumber: string) => this.instance.get<TravelContract>(`/travel/${policyNumber}`);

    public terminateContract = (policyNumber: string) => this.instance.delete(`/travel/${policyNumber}`);

    public getPeriods = () => this.instance.get<any>("/travel/periods");

    public getCountries = () => this.instance.get<any>("/travel/countries");

    public getCurrencies = () => this.instance.get<any>("/travel/currencies");

    public calculate = (data: any) => this.instance.post<any>("/travel/calculate", data);

    public issue = (data: any) => this.instance.post<any>("/travel", data);
}

export default new TravelApi();